
<div class="form-group" *ngIf="job.inputType">
  <task-input (enter)="enter.emit()" [args]="vars" [inputType]="job.inputType"></task-input>
</div>
<div class="form-group" *ngFor="let field of job.variableDefinitions">
  <label>{{ field.name }}</label>
  <custom-field-input (enter)="enter.emit()" [required]="!field.optional" [(ngModel)]="vars[$any(field.name)]" [field]="$any(field)"></custom-field-input>
</div>